import { featuresData } from '@/mocks/homeData';

export default function SectionFeatures() {
  return (
    <section id="features" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100/70">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
            为什么选我们
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">本站优势</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">做最专业的吃瓜平台，给你最好的吃瓜体验</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-4xl mx-auto">
          {featuresData.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8 text-center hover:border-primary-200 transition-all duration-300 cursor-default"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto rounded-lg bg-primary-100">
                <i className={`${item.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="mt-5 text-base md:text-lg font-semibold text-foreground-900 font-heading">
                {item.title}
              </h3>
              <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}